export const BASEURL = `https://community.venco.africa/api/method`
export const BASE_DOMAIN = `https://community.venco.africa`

export const STAGING_BASEURL = `https://community.01101960.xyz/api/method`
export const STAGING_BASE_DOMAIN = `https://community.01101960.xyz`

export const OFFICE_BASE_URL = `https://office.venco.africa`

